import React, { useEffect, useState } from "react";
import "./ChatbotSectionStyle.css";
import FiltersComponent from "../FiltersComponents/FiltersComponent";
import FinalChatBotView from "../chatBot/FinalChatBotView";
function ChatbotSection() {
  const [isChatbotVisible, setIsChatbotVisible] = useState(false);
  const [isChatbotLoading, setIsChatbotLoading] = useState(false); // Loader state
  const [hasFocusedOnce, setHasFocusedOnce] = useState(false); // Track if focus has happened

  // const initializeChatbot = () => {
  //   window.companyId = "1c95112d-6790-4fa4-94bc-dd9f0334ce00";
  //   if (!document.getElementById("aiiro-chat-bot-root")) {
  //     const div = document.createElement("div");
  //     div.id = "aiiro-chat-bot-root";
  //     const root = document.getElementById("root");

  //     if (root && root.children.length >= 3) {
  //       root.insertBefore(div, root.children[3]);
  //     } else {
  //       root.appendChild(div);
  //     }
  //   }

  //   const script = document.createElement("script");
  //   const link = document.createElement("link");
  //   script.defer = true;
  //   script.src =
  //     "https://bot.aiiro.ai/static/js/aiiro.main.d005272ab6ab726eb9ca.js?version=1735313150257";
  //   link.rel = "stylesheet";
  //   link.href =
  //     "https://bot.aiiro.ai/static/css/aiiro.main.d005272ab6ab726eb9ca.css?version=1735313150257";
  //   script.onload = () => {
  //     setIsChatbotLoading(false); // Remove loader once chatbot script is loaded
  //   };
  //   document.head.insertBefore(script, document.head.lastChild);
  //   document.head.insertBefore(link, document.head.lastChild);
  // };

  const adjustFormAndWidget = () => {
    const form = document.querySelector(".styles_footerBox__bPpNb");
    const formBtn = document.querySelector(".styles_footerButton__dHGZH");
    const textarea = form?.querySelector("textarea");
    const messageWidget = document.querySelector(".styles_bodyBox__MhRTU");
    const outerChatbotContainer = document.querySelector(
      ".chatbotOuterContainer"
    );
    const mainDivAfterRoot = document.querySelector(
      ".styles_chatBotWidget__wwNq1"
    );
    // const disclaimerTxt = document.querySelector(
    //   ".styles_additionalText__cQfvn "
    // );
    // textarea.placeholder =
    //   "Ask anything about the companies you've selected...";
    // disclaimerTxt.innerText =
    //   "aiiro can make mistakes and doesn't give financial advice. More specific questions will result in better responses. Validate important information.";
    if (form && textarea && !hasFocusedOnce) {
      if (!isChatbotVisible) {
        outerChatbotContainer.style.minHeight = "auto";
        // mainDivAfterRoot.style.minHeight = "auto";
        // mainDivAfterRoot.style.height = "auto";
        // Hide the message widget
        // if (messageWidget) {
        //   messageWidget.style.display = "none";
        // }
      }
      textarea.addEventListener("focus", () => {
        setIsChatbotVisible(true); // Switch to normal position on focus
        setHasFocusedOnce(true); // Prevent further focus triggers
        if (outerChatbotContainer) {
          outerChatbotContainer.style.minHeight = "110dvh";
          // Wait for the next render before scrolling
          setTimeout(() => {
            outerChatbotContainer.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 300);
        }
      });
      // else {
      //   // if (formBtn) formBtn.style.height = "";
      //   // Show the message widget
      //   if (messageWidget) {
      //     messageWidget.style.display = "flex";
      //   }
      // }

      // Add focus event to switch back to normal position
    }
  };
  const enforceFormAdjustment = () => {
    // Continuously enforce the position every 500ms
    const interval = setInterval(() => {
      const form = document.querySelector(".styles_footerBox__bPpNb");
      if (form) {
        adjustFormAndWidget();
      }
    }, 500);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  };

  useEffect(() => {
    // initializeChatbot();

    // Wait for the chatbot to load, then adjust the form position
    const observer = new MutationObserver(() => {
      const form = document.querySelector(".styles_footerBox__HERzB");
      if (form) {
        adjustFormAndWidget();
        observer.disconnect(); // Stop observing once the form is found
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Enforce the adjustment as a fallback
    const cleanupEnforce = enforceFormAdjustment();

    return () => {
      observer.disconnect();
      cleanupEnforce();
    };
  }, [isChatbotVisible]); // Re-run the effect when the position state changes

  return (
    <div className="chatbotOuterContainer">
      <FiltersComponent />
      {isChatbotLoading && (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading chatbot...</p>
        </div>
      )}
      <div id="aiiro-chat-bot-root">
        <FinalChatBotView />
      </div>
    </div>
  );
}

export default ChatbotSection;
